import React, { useEffect, useState } from "react";
import OnestockPaymentContainer from "containers/JarvisOnestock/OnestockPayment";
import { useDispatch, useSelector } from "react-redux";
import AssessmentModal from "components/Assessment/AssessmentModal";
import { jarvsiOnestockOnboardingActions } from "stores/jarvisOnestock/jarvisOnestockOnboarding/jarvisOnestockOnboardingAction";
import { masterActions } from "stores/master/masterActions";

function OnestockPayment() {
  const [openModal, setOpenModal] = useState(false);

  const getCurrentStage = useSelector(
    (state) => state.jarvisOnestock.onestockOnboarding.currentStage
  );
  const dispatch = useDispatch();

  const onboardingStages = [
    {
      stageId: ["RISK_ASSESSMENT"],
      stageNumber: 1,
    },
    {
      stageId: ["PAYMENT"],
      stageNumber: 2,
    },
    {
      stageId: ["CKYC", "DOCUMENT_SIGNING"],
      stageNumber: 3,
    },
  ];

  const getActiveStage = () => {
    return onboardingStages.find((o) => o.stageId.includes(getCurrentStage));
  };

  const activeStage = getActiveStage();

  useEffect(() => {
    if (activeStage.stageNumber >= 1) {
      setOpenModal(true);
    }
  }, []);

  const handleClose = () => setOpenModal(false);

  const handleConfirm = () => {
    setOpenModal(false);
    dispatch(
      jarvsiOnestockOnboardingActions.updateOnestockOnboardingData({
        currentStage: "RISK_ASSESSMENT",
      })
    );
    dispatch(masterActions.getFirstRender(false));
    console.log("Continue with risk profile update...");
  };

  return (
    <>
      <OnestockPaymentContainer />

      <AssessmentModal
        open={openModal}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  );
}

export default OnestockPayment;
